import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertType } from '../components/generic-alert/generic-alert.component';

export interface Alert {
  /** Identificador único de cada alerta, usado para disparar o componente mesmo com a mesma mensagem */
  id: number;
  type: AlertType;
  message: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private readonly alertSubject = new BehaviorSubject<Alert | null>(null);
  alert$ = this.alertSubject.asObservable();
  private counter = 0;

  showSuccess(message: string, duration: number = 5000) {
    this.alertSubject.next({
      id: ++this.counter,
      type: 'success',
      message,
      duration
    });
  }

  showError(message: string, duration: number = 5000) {
    this.alertSubject.next({
      id: ++this.counter,
      type: 'error',
      message,
      duration
    });
  }

  clear() {
    this.alertSubject.next(null);
  }
} 